/**
 * Shared page-layout tokens, ported from botriq-admin-fe's `components/ui/layout.js`
 * so the two portals lay their pages out by the same rule.
 *
 * Pages span the FULL width of the content card (MainLayout owns the outer inset).
 * Never add a fixed `width`; a cap with no `mx: "auto"` is left-aligned by
 * definition, which is what stranded every list page in a 1200px column.
 */

/**
 * Items per page, by view. 12 divides by the 2/3/4 column counts the grid
 * produces, so its last row always fills.
 */
export const PAGE_SIZE = { grid: 12, list: 10 };

/** Readability cap for prose (Terms, Privacy). Only ever applied with `mx: "auto"`. */
export const PROSE_MAX_WIDTH = 860;

/**
 * Spread onto the outermost <Box> of a page. `embedded` (a page rendered inside
 * another page's shell) drops its own padding — the host already paid it — but
 * keeps `width`/`minWidth`, which are what stop it overflowing.
 */
export const pageContainerSx = ({ embedded = false, prose = false } = {}) => ({
  px: embedded ? 0 : { xs: 2, sm: 3 },
  pt: embedded ? 0 : { xs: 1.5, sm: 2 },
  pb: embedded ? 0 : { xs: 2, sm: 3 },
  width: "100%",
  // Stops a child with an intrinsic min-width (long strings, wide tables) from
  // forcing the whole page to scroll horizontally on mobile.
  minWidth: 0,
  // `prose` is the one sanctioned cap (Terms, Privacy). Cap and centring travel
  // together here so a call site can't separate them.
  ...(prose && !embedded ? { maxWidth: PROSE_MAX_WIDTH, mx: "auto" } : {}),
});
